import { render, staticRenderFns } from "./pages15.vue?vue&type=template&id=413e7a43&scoped=true&"
import script from "./pages15.vue?vue&type=script&lang=js&"
export * from "./pages15.vue?vue&type=script&lang=js&"
import style0 from "./pages15.vue?vue&type=style&index=0&id=413e7a43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e7a43",
  null
  
)

export default component.exports